module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_Regular.48d656ed.ttf";